// extracted by mini-css-extract-plugin
export default {"main":"style_main__e+hYi","mainBG":"style_mainBG__jVRF+","asFlex":"style_asFlex__dWeCk"};